/* =========================================================
   The Details — accordion behavior + reveal + keyboard nav
   ========================================================= */

(function () {
  'use strict';

  function initDetails(root) {
    if (!root || root.dataset.detailsInit === 'true') return;
    root.dataset.detailsInit = 'true';

    const items = Array.from(root.querySelectorAll('.details__item'));
    const closeOthers = root.dataset.closeOthers === 'true';

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -40px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }

    // ---------- Accordion behavior ----------
    if (closeOthers) {
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            items.forEach((other) => {
              if (other !== item && other.open) other.open = false;
            });
          }
        });
      });
    }

    // ---------- Anchor → open matching item ----------
    function handleHash() {
      const hash = window.location.hash;
      if (!hash || !hash.startsWith('#details-')) return;

      const slug = hash.replace('#details-', '').toLowerCase();
      items.forEach((item) => {
        const title = item.querySelector('.details__title');
        if (!title) return;

        const itemSlug = title.textContent
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-');

        if (itemSlug === slug || itemSlug.includes(slug)) {
          item.open = true;
          setTimeout(() => {
            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        }
      });
    }

    handleHash();
    window.addEventListener('hashchange', handleHash);

    // ---------- Keyboard navigation ----------
    items.forEach((item, index) => {
      const summary = item.querySelector('.details__summary');
      if (!summary) return;

      summary.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = items[index + 1];
          if (next) next.querySelector('.details__summary').focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = items[index - 1];
          if (prev) prev.querySelector('.details__summary').focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          items[0].querySelector('.details__summary').focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          items[items.length - 1].querySelector('.details__summary').focus();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.details[data-section-id]').forEach(initDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.details[data-section-id]');
    if (root) initDetails(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.details[data-section-id]');
    if (root) root.dataset.detailsInit = '';
  });
})();
